import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const uploadProgressStyles: SxStyles = {
  uploadProgressContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: getResponsiveSize(200),
    '& .spinner': {
      color: theme.palette.myPrimary?.lightBlue50,
      mb: getResponsiveSize(25),
    },
    '& .cancel-upload-btn': {
      backgroundColor: '#65B3CF',
      width: getResponsiveSize(135.1),
      height: getResponsiveSize(35),
      borderRadius: getResponsiveSize(4),
      fontFamily: theme.typography.mainFontFamily,
      fontSize: getResponsiveSize(12),
      lineHeight: 2.2,
      color: theme.palette.primary.contrastText,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: theme.palette.myPrimary?.lightBlue100,
      },
    },
  },
};
